import { OrderStatus } from 'constants/enums';
import { OrderDetails } from 'types/order.interface';

export const isOrderCancellable = (order: OrderDetails) => (
  ![OrderStatus.CANCELLED, OrderStatus.DECLINED].includes(order.status)
);
